import moment from 'moment'
import * as _ from 'lodash'
import dataWranglingUtils from '../dataWrangling/utils'

export default ['$q', 'locklessService', planningService]
function planningService($q, locklessService) {
  this.schedulePublication = function schedulePublication(storyObj) {
    // https://wapo-rtd.ext.nile.works/docs/contentoperationsapi/en/stable/rest_api_spec.html#put--publish
    const publicationDetails = {
      _id: storyObj._.get(storyObj, '_id'),
      type: 'story_operation',
      editions: ['default'],
      date: _.get(storyObj, 'planning.scheduling.scheduled_publish_date'),
      display_date: _.get(storyObj, 'display_date'),
      revision_id: _.get(storyObj, 'revision.revision_id'),
      operation: 'publish_edition',
    }
    return locklessService.schedulePublication(publicationDetails)
  }

  this.loadScheduledPublications = function loadScheduledPublications(storyId) {
    return locklessService.loadScheduledPublications(storyId)
  }

  this.getPlanningTimes = function getPlanningTimes() {
    const defer = $q.defer()
    /*
     * Thinking in functional tuples.
     */
    locklessService.loadStoryObject().then(function(storyObj) {
      defer.resolve({
        planned_publish_date: dataWranglingUtils.transformDataTypes(
          dataWranglingUtils.dataTypeOrNull(
            dataWranglingUtils.extractProperties(storyObj, [
              'planning.scheduling.planned_publish_date',
            ]),
            [dataWranglingUtils.isStringType, dataWranglingUtils.isDateType]
          ),
          [
            [
              dataWranglingUtils.isNull,
              function(item) {
                return null
              },
            ],
            [
              dataWranglingUtils.isStringType,
              dataWranglingUtils.ansStringToDate,
            ],
            [
              dataWranglingUtils.isDateType,
              function(item) {
                return moment(item).tz(window.org_settings.timezone)
              },
            ],
          ]
        ),
        scheduled_publish_date: dataWranglingUtils.transformDataTypes(
          dataWranglingUtils.dataTypeOrNull(
            dataWranglingUtils.extractProperties(storyObj, [
              'planning.scheduling.scheduled_publish_date',
            ]),
            [dataWranglingUtils.isStringType, dataWranglingUtils.isDateType]
          ),
          [
            [
              dataWranglingUtils.isNull,
              function(item) {
                return null
              },
            ],
            [
              dataWranglingUtils.isStringType,
              dataWranglingUtils.ansStringToDate,
            ],
            [
              dataWranglingUtils.isDateType,
              function(item) {
                return moment(item).tz(window.org_settings.timezone)
              },
            ],
          ]
        ),
      })
    })
    return defer.promise
  }
}
